import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from './filters.service';
import axios from 'axios';
import { Injectable } from '@angular/core';
import { ACUpdateRequest } from 'src/app/features/action-center/types/action-center-types';
import { HttpClientService } from './http-client.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ActionCenterRequests {
  private ENDPOINT_BASE_PATH = '/recommendations';
  private filters: ContractModel | undefined;
  private readonly userName: string;

  constructor(
    private httpClientService: HttpClientService,
    private filtersService: FiltersService,
    userService: UserService
  ) {
    this.userName = userService.getUsername()!.toLowerCase();
    this.filtersService.selectedFiltersObservable.subscribe(
      (f) => (this.filters = f)
    );
  }

  getRecommendations(recStatus: string) {
    try {
      if (this.filters == undefined) {
        throw new Error('filterData is undefined');
      }

      const payload = {
        division: this.filters.division,
        dataView: this.filters.dataView,
        topLevelContractGroup: this.filters.topLevelContractGroup,
        secondLevelContractFilter: this.filters.secondLevelContractFilter,
        thirdLevelContractFilter: this.filters.thirdLevelContractFilter,
        fourthLevelContractFilter: this.filters.fourthLevelContractFilter,
        accts: this.filters.accts,
      };

      // TODO: Consider not sending the username as it is now available in the access token sent to the API
      let url = `${this.ENDPOINT_BASE_PATH}/${this.userName}/${recStatus}?region=${this.filters.regions}&countries=${this.filters.countries}&period=${this.filters.period}`;
      url = this.filtersService.appendCustomDateRangeToUrl(url);
      return this.httpClientService.post(
        url,
        payload
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }

  async moveToNewState(acRequest: ACUpdateRequest) {
    try {

      if (this.filters == undefined) {
        throw new Error('filterData is undefined');
      }

            const payload = {
                contractModel: {
                    division: this.filters.division,
                    dataView: this.filters.dataView,
                    topLevelContractGroup: this.filters.topLevelContractGroup,
                    secondLevelContractFilter: this.filters.secondLevelContractFilter,
                    thirdLevelContractFilter: this.filters.thirdLevelContractFilter,
                    fourthLevelContractFilter: this.filters.fourthLevelContractFilter,
                    accts: this.filters.accts,
                },
                recId: acRequest.recId,
                state: acRequest.state,
                locationIds: acRequest.locationIds,
                solution: acRequest.solution,
                productName: acRequest.productName,
            };

      // TODO: Consider not sending the username as it is now available in the access token sent to the API
      let url = `${this.ENDPOINT_BASE_PATH}/update/${this.userName}?region=${this.filters.regions}&countries=${this.filters.countries}&period=${this.filters.period}`;
      url = this.filtersService.appendCustomDateRangeToUrl(url);
      return await this.httpClientService.post(
        url,
        payload
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }
}